import Header from "../component/header";
import Footer from "../component/footer";
import Lenis from 'lenis'

function Terms() {

        const lenis = new Lenis({
        duration: 2.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
        direction: 'vertical', // vertical, horizontal
        gestureDirection: 'vertical', // vertical, horizontal, both
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: true,
        touchMultiplier: 2,
        infinite: false,
      })

//get scroll value
lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
console.log({ scroll, limit, velocity, direction, progress })
})

function raf(time) {
lenis.raf(time)
requestAnimationFrame(raf)
}

requestAnimationFrame(raf)
    return (
    <main>
        <Header/> 
         <div id="smooth-wrapper">
        <div id="smooth-content">
            {/* <!-- Add your site or application content here --> */}
            <main>

                {/* <!-- page title area start --> */}
                <section className="page-title-area section-spacing primary-bg p-relative adjust-header-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-9">
                                <div className="page-title-wrappper is-white">
                                    <div className="breadcrumb-menu mb-20">
                                        <nav aria-label="Breadcrumbs" className="breadcrumb-trail breadcrumbs">
                                            <ul className="trail-items">
                                                <li className="trail-item trail-begin"><span>Effective Date:</span></li>
                                                <li className="trail-item"><span>May 1, 2025</span></li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <h2 className="page-title mb-35 animation__word_come_long">Terms of Service for Ally – AI Virtual Assistant</h2>
                                    {/* <!-- <p className="page-title-paragraph xlarge p-text">We showcased how our skilled hands and
                                        creative minds turn a concept into a fully-functional product. Here, you will
                                        discover satisfied clients with amazing stories!</p> --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- page title area end --> */}
                <section className="section-spacing">
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-12">

                                <h4 className="case-subtitle mb-25"><span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                                fill="#14CF93" />
                                        </svg>
                                    </span>Scope of Service
                                </h4>
                                    <p className="mb-55">Ally is an AI-powered virtual assistant designed to:<br/>
                                   - Assist with pre-sales queries for prospective and existing customers.<br/>
                                   - Provide HR support and respond to general internal organizational inquiries.<br/>
                                    The assistant may be accessed via web interfaces, embedded widgets, or integrated chat
                                    tools approved by Mystra Technologies LLP.</p>
                              
                                <h4 className="case-subtitle mb-25"><span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                                fill="#14CF93" />
                                        </svg>
                                    </span>User Responsibilities
                                </h4>
                                <p className="mb-30">By using Ally, you agree to:<br/>
                               - Use the assistant only for lawful and authorized purposes.<br/>
                                    - Provide accurate and honest information during interactions. <br/>
                                         - Not use Ally to transmit any content that is unlawful, harmful, offensive, or infringing on
                                    third-party rights.<br/>
                                    - Not attempt to reverse engineer, disrupt, or damage Ally or its associated systems.</p>

                                    <h4 className="case-subtitle mb-25"><span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                                fill="#14CF93" />
                                        </svg>
                                    </span> Acceptable Use </h4>
                                <p className="mb-30">
                                    You shall not:<br />
                                    - Use Ally for any illegal, unethical, or malicious activity.<br />
                                    - Input or request confidential personal data not relevant to the stated purposes (e.g.,
                                    passwords, payment details).<br />
                                    - Use Ally to impersonate others or misrepresent your affiliation.<br />
                                    Violation of acceptable use terms may result in suspension or termination of access.
                                </p>
                                
                                <h4 className="case-subtitle mb-25"><span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                                fill="#14CF93" />
                                        </svg>
                                    </span> Intellectual Property </h4>
                                <p className="mb-30">
                                    All rights, title, and interest in and to Ally, including but not limited to its AI models,
                                    interface, training data, content, and branding, are owned by Mystra Technologies LLP.<br />
                                    Users may not reproduce, distribute, modify, or create derivative works without prior
                                    written permission.
                                </p>
                                
                                <h4 className="case-subtitle mb-25"><span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                                fill="#14CF93" />
                                        </svg>
                                    </span> Third-Party Integrations </h4>
                                <p className="mb-30">
                                    Ally may interface with third-party services (e.g., HRMS, CRM, scheduling tools). We do not
                                    control or endorse third-party content and are not liable for their actions. Your use of such
                                    services is subject to their own terms.
                                </p>
                                
                                <h4 className="case-subtitle mb-25"><span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                                fill="#14CF93" />
                                        </svg>
                                    </span> No Guarantees or Warranties </h4>
                                <p className="mb-30">
                                    Ally is provided on an “as-is” and “as-available” basis. We do not warrant that:<br />
                                    - The responses will be 100% accurate, complete, or timely.<br />
                                    - The service will be uninterrupted or error-free.<br />
                                    - Any issues will be resolved immediately or to your satisfaction.<br />
                                    The AI is designed to assist but not replace human judgment, especially in business-critical
                                    or sensitive decisions.
                                </p>
                                
                                <h4 className="case-subtitle mb-25"><span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                                fill="#14CF93" />
                                        </svg>
                                    </span> Limitation of Liability </h4>
                                <p className="mb-30">
                                    To the fullest extent permitted by law, Mystra Technologies LLP shall not be liable for:<br />
                                    - Any direct, indirect, incidental, consequential, or punitive damages arising from the use or
                                    inability to use Ally.<br />
                                    - Any reliance placed on the AI’s suggestions or outputs.<br />
                                    - Any errors, omissions, or inaccuracies in the information provided by Ally.
                                </p>
                                
                                <h4 className="case-subtitle mb-25"><span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                                fill="#14CF93" />
                                        </svg>
                                    </span> Indemnification </h4>
                                <p className="mb-30">
                                    You agree to indemnify and hold harmless Mystra Technologies LLP, its affiliates, officers,
                                    and employees from any claim or demand (including legal fees) arising out of:<br />
                                    - Your use of Ally<br />
                                    - Your violation of these Terms of Service<br />
                                    - Your violation of any rights of a third party
                                </p>
                                
                                <h4 className="case-subtitle mb-25"><span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                                fill="#14CF93" />
                                        </svg>
                                    </span> Termination </h4>
                                <p className="mb-30">
                                    We reserve the right to terminate or suspend your access to Ally at our sole discretion,
                                    without prior notice, for conduct that we believe violates these Terms or is harmful to other
                                    users or to the Company.
                                </p>
                                
                                <h4 className="case-subtitle mb-25"><span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                                fill="#14CF93" />
                                        </svg>
                                    </span> Changes to Terms </h4>
                                <p className="mb-30">
                                    We may update these Terms of Service at any time. Continued use of Ally after changes are
                                    made constitutes your acceptance of the updated terms. The current version will always be
                                    available on our platform.
                                </p>
                                
                                <h4 className="case-subtitle mb-25"><span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                                fill="#14CF93" />
                                        </svg>
                                    </span> Governing Law </h4>
                                <p className="mb-30">
                                    These Terms shall be governed by and construed in accordance with the laws of the
                                    Republic of India, with exclusive jurisdiction of the courts of Kochi, Kerala.
                                </p>
                                <h4 className="case-subtitle mb-25"><span>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                                fill="#14CF93" />
                                        </svg>
                                    </span> Contact Us </h4>
                                <p className="mb-30">
                                    If you have any questions about these Terms, please contact us at:
                                </p>     

                                <h4 className="case-subtitle mb-25">
                                    Mystra Technologies LLP<br/>
                                    Email: support@mystra.in
                                </h4>
                               
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- faq area end -->
                <!-- title intro area --> */}
                <section className="title-intro-area">
                    <div className="container">
                        <div className="title-intro-wrapper is-center section-spacing">
                            <div className="intro__title-wrapper">
                                <h2 className="intro__title-inner folks-text">Let’s talk.</h2>
                            </div>
                            <div className="intro-brn">
                                <a href="/mystra-contact" className="circle-btn is-green">
                                    <span className="icon-box"><i className="flaticon-next"></i></span>
                                    <img src="assets/img/icons/contact-btn-text.png" alt="contact-btn-text.png"
                                        className="image-text"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- title intro end --> */}

            </main>

            {/* <!-- footer-area-start --> */}
             <Footer/>
            {/* <!-- footer-area-end --> */}
        </div>
    </div>

    {/* <!-- back to top start --> */}
    <div className="progress-wrap">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>
    {/* <!-- back to top end --> */}
    </main>
)}

export default Terms;
    